import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, interval, mapTo, merge, Observable, Subject, Subscription } from 'rxjs';

import { CookieService } from 'ngx-cookie-service';
import { AppConstants } from '../app-constants';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Injectable({
  providedIn: 'root'
})
export class ApisService {
  private idleTime = 15 * 60 * 1000;
  private checkInterval = 10000; // check every 10 sec
  private activityEvents = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress', 'touchstart'];
  private lastActiveKey = 'lastActiveTimestamp';
  private timerSub: Subscription | null = null;
  public loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  calenderRangeSub = new Subject<any>();
  constructor(private httpClient: HttpClient,private modalService: NgbModal, private cookieService: CookieService, private ngZone: NgZone, private router: Router) {
      this.initListeners();
    this.startTimer();

    // this.handleVisibilityChange();
    // this.listenToStorageEvents();
   }
ngOnInit() {
  this.initListeners();
    this.startTimer();
}
  getApi(url: any, header: any): Observable<any> {
    return this.httpClient.get<any>(environment.base_url + url, header)
  }
  postApi(url: any, reqbody: any, header: any): Observable<any> {
    console.log(url, reqbody)
    return this.httpClient.post<any>(environment.base_url + url, reqbody, header)
  }

  showLoader() {
    this.loadingSubject.next(true);
  }

  hideLoader() {
    this.loadingSubject.next(false);
  }
  cleanupOnLogout() {
    // this.modalService.dismissAll('logout');
    this.router.navigate([AppConstants.RoutingPaths.login]);
    localStorage.clear();
    sessionStorage.clear();
    this.cookieService.deleteAll('/');
    this.cookieService.delete('connect.sid');
    sessionStorage.removeItem('isAuthenticated');
this.modalService.dismissAll()
    console.log('redirected login: ');
    // this.loaderService.isLoading.next(false);
  }
  getCalenderStatus(): Observable<boolean> {
    return this.calenderRangeSub.asObservable();
  }

  setCalenderStatus(hide: boolean) {
    this.calenderRangeSub.next(hide);
  }
  startTimer() {
    this.ngZone.runOutsideAngular(() => {
      this.timerSub = interval(this.checkInterval).subscribe(() => {
        const lastActive = parseInt(localStorage.getItem(this.lastActiveKey) || '0', 10);
        const now = Date.now();
        const diff = now - lastActive;
console.log(lastActive,'lastActive')
        if (diff > this.idleTime) {
          this.cleanupOnLogout();
        }
      });
    });
  }
  initListeners() {

      this.activityEvents.forEach(event => {
      
    window.addEventListener(event, () =>{
  
         const now = Date.now();
      localStorage.setItem(this.lastActiveKey, now.toString());
    });
  });
//     const activity$ = merge(
//       ...this.activityEvents.map((e: any) => fromEvent(document, e).pipe(mapTo(e)))
//     );
// console.log("initListeners")
//     activity$.subscribe(() => {
//       const now = Date.now();
//       localStorage.setItem(this.lastActiveKey, now.toString());
//     });
  }
   handleVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        // Refresh timestamp if user comes back
        localStorage.setItem(this.lastActiveKey, Date.now().toString());
      }
    });
  }

}
